export const validate = (value) => {
  // info: Possibly it could be improved, but I wanted to save time on grinding
  //       the perfect expiry solution that probably is out there somewhere as
  //       3rd party.

  const expiryRegExp = /^(0[1-9]|10|11|12)\/[2-9][0-9]$/;

  return !!expiryRegExp.test(value);
};
